import React from 'react';
export const LandingPage = (props) => {
	return (
		<section className='landing-page'>
			{props.children}
			<div className='title-container'>
				<span className='greeting'>
					{props.greeting}
				</span>
				<h1 className='main-heading'>
					<span className='i-am'>
						<span className='i'>
							I&nbsp;
						</span>
						<span className='am'>
							am
						</span>
					</span>
					<span className='name-container'>
						<span className='animation-block name-block'></span>
						<span className='name'>
							Tracey
						</span>
					</span>
				</h1>
				<span className='sub-heading'>
					<span className='role-container'>
						<span className='animation-block role-block'></span>
                        <span className='role'>
                            {'<Full Stack Engineer />'}
						</span>
					</span>
				</span>
			</div>
		</section>
	);
};
